import ProductDetailsSampleOrderLimitModalClass from "./product-details-sample-order-limit-modal-class";
import "./product-details-sample-order-limit-modal.scss";

const modalInstances = new Map();

const getPdpDynamicData = () => window.document.pdpDynamicData;

const getModalInstance = modalSelector => {
  if (!modalInstances.has(modalSelector)) {
    const instance = new ProductDetailsSampleOrderLimitModalClass(modalSelector);
    instance.init();
    modalInstances.set(modalSelector, instance);
  }
  return modalInstances.get(modalSelector);
};

const getAppropriateModalSelector = () => {
  const pdpData = getPdpDynamicData();
  if (!pdpData) return null;

  const userSampleOrdersCount = pdpData?.user_sample_orders_count || 0;
  const madeSampleLineItemCount = pdpData?.made_sample_line_item_count || 0;
  const sampleOrderLimit = pdpData?.sample_order_limit || 5;

  // Priority: historical order limit first (more restrictive), then current cart samples
  if (userSampleOrdersCount >= sampleOrderLimit) {
    return "#js-pdp-sample-order-limit-modal";
  }
  if (madeSampleLineItemCount >= 1) {
    return "#js-pdp-sample-already-in-cart-modal";
  }
  return null;
};

export const showSampleLimitModal = () => {
  const modalSelector = getAppropriateModalSelector();
  if (!modalSelector) return;

  const $modalElement = document.getElementById(modalSelector.replace("#", ""));
  if (!$modalElement) return;

  const modal = getModalInstance(modalSelector);
  modal.openModal();
};

const initModalInstance = modalSelector => {
  const $modal = document.getElementById(modalSelector.replace("#", ""));
  if (!$modal) return;

  getModalInstance(modalSelector);
};

export default () => {
  initModalInstance("#js-pdp-sample-order-limit-modal");
  initModalInstance("#js-pdp-sample-already-in-cart-modal");
};
